import { ForgotPasswordForm } from './components/ForgotPasswordForm';
import logo from '../../assets/logo.png';

export default function ForgotPasswordPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ 
      backgroundImage: 'url("https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1920")',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black opacity-80"></div>
      
      {/* Content */}
      <div className="relative z-10 w-full max-w-md">
        {/* Logo and Title */}
        <div className="text-center mb-8">
          <img
            src={logo}
            alt="Gymnet Logo"
            className="mx-auto h-16 w-18 mb-4"
          />
          <p className="text-xs text-gray-400 uppercase tracking-widest">ADMIN COMMAND CENTER</p>
        </div>

        {/* Main Heading */}
        <h2 className="text-3xl font-bold text-white text-center mb-2">Reset Your Password</h2>
        <p className="text-gray-400 text-center text-sm mb-8">Enter your email to receive a verification code.</p>

        {/* Form Card */}
        <div className="bg-gray-900 bg-opacity-50 backdrop-blur-sm rounded-lg p-8 shadow-2xl border border-gray-800">
          <ForgotPasswordForm />
        </div>

        {/* Footer Links */}
        <div className="text-center mt-6">
          <p className="text-gray-500 text-sm">
            Remember your password?{' '}
            <a href="/login" className="transition-colors" style={{ color: '#23F47C' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#1de06d')}
              onMouseLeave={(e) => (e.currentTarget.style.color = '#23F47C')}
            >
              Back to Login
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
